<template>
  <div class="chart-bar vertical mt-40">
    <ul :class="['bars', {'multi-line': this.multiline}]">
      <li v-for="(xvalues,index) in details.xvalues" :key="index" :style="`height:${xvalues.style}%`" :class="xvalues.class">
        <label>{{xvalues.label}}</label>
      </li>
    </ul>
    <ul class="lines">
      <li v-for="(yvalue,index) in details.yvalues" :key="index" :class="`t-${index+1}`">
        <label>{{ yvalue }}</label>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    graphDetail: {
      type: Object
    },
    headerConstant: {
      type: Object
    },
    multiline: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    details() {
      const values = Object.values(this.graphDetail);
      const maxValue = Math.max(...values);
      const nearestThreeMultiple = (3 - (maxValue % 3)) + maxValue;
      const barChartMin = nearestThreeMultiple / 3;
      const yvalues = [
        barChartMin * 3,
        barChartMin * 2,
        barChartMin,
        0,
      ];

      const xvalues = [];
      this.headerConstant.bars.forEach((bar) => {
        const val = this.graphDetail ? this.graphDetail[bar.labelColumn] : 0;
        const percentage = (val / nearestThreeMultiple) * 100;
        xvalues.push({ label: bar.label, style: percentage, class: bar.class });
      });
      return { xvalues, yvalues };
    },
  },
};
</script>
